<template>
    <div class="detail-body">
        <div class="detail-top">
            <backindex :msg="detailMsg"></backindex>
        </div>
        <!--添加{{$t("cmt")}}区域-->
        <div class="see-comment">
            <div class="comment-title">{{$t("cmtList")}}</div>
            <textarea v-model="cmt" class="cmt-text" :placeholder="tips"></textarea>
            <div @click="cmtAdd" class="read-btn">{{$t("cmt")}}</div>
        </div>
        <!--{{$t("cmt")}}展示呢区域-->
        <div class="comment-area">
            <div class="comment-item" v-for="(item,index) in comment_list" :key="index">
                <div class="user-photo">
                    <div class="photo-img">
                        <img :src="item.uimg" alt="">
                    </div>
                </div>
                <div class="user-info">
                    <div class="user-name">{{item.uname}}</div>
                    <div class="comment-time">{{item.add_time_text}}</div>
                    <div class="comment-con">{{item.info}}</div>
                    <div class="zan-area">
                        <img src="../assets/imgs/zan.png" @click="cmtDigg(item.id)">
                        <span>{{item.digg}}</span>
                    </div>
                </div>
            </div>
        </div>
        <pagebottom></pagebottom>
    </div>
</template>

<script>
import backindex from "@/components/common/backindex";
import pagebottom from "@/components/common/pagebottom";
export default {
  name: "cmtlist",
  components: {
    backindex,
    pagebottom
  },
  data() {
    return {
      bookId: this.$route.query.id,
      detailMsg: "评论专区",
      cmt: "",
      tips:"",
      page: 1,
      pageInfo: {},
      comment_list: []
    };
  },
  mounted: function() {
    this.getCmtList();
    this.detailMsg=this.$t("cmtList");
    this.tips = this.$t("inputCmt");
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    //列表id
    getCmtList() {
      this.$indicator.open({
        text: "Loading...",
        spinnerType: "fading-circle"
      });
      this.req.cmtList(this.bookId, this.page).then(res => {
        this.$indicator.close();
        if(res){
            this.comment_list = res.data.list;
            this.pageInfo = res.data.pageInfo;
        }
      });
    },
    //点赞
    cmtDigg(id) {
      this.req.cmtDigg(id).then(res => {
        for (var i = 0; i < this.comment_list.length; i++) {
          if (this.comment_list[i].id == id) {
            this.comment_list[i].digg = res.data.data;
            break;
          }
        }
      });
    },
    //添加{{$t("cmt")}}
    cmtAdd() {
      this.req.cmtAdd(this.bookId, this.cmt).then(res => {
          if(res){
              this.cmt = "";
              this.getCmtList();
          }
      });
    },
    handleScroll: function() {
      let scrollTop = document.documentElement.scrollTop;
      let scrollHeight = document.documentElement.scrollHeight;
      let clientHeight = this.$J("#app").height();
      if (scrollHeight - scrollTop <= clientHeight + 200) {
        if (this.page >= this.pageInfo.totalPage) {
          return;
        }
        this.page += 1;
        this.req.cmtList(this.bookId, this.page).then(res => {
          res.data.list.map(item => {
            this.comment_list.push(item);
          });
          this.pageInfo = res.data.pageInfo;
        });
      }
    }
  }
};
</script>

<style scoped>
    .detail-body {
        width: 100%;
        height: auto;
        padding-top: 1.12rem;
    }
    .detail-top {
        width: 100%;
        position: fixed;
        left: 0;
        top: 0;
    }
    /*{{$t("cmt")}}*/
    .see-comment {
        width: 100%;
        height: auto;
        background: #ffffff;
        padding: 0.4rem;
        border-bottom: 0.02rem solid #e6e6e6;
        box-sizing: border-box;
        overflow: hidden;
    }
    .comment-title {
        font-size: 0.3rem;
        line-height: 0.3rem;
        font-weight: 700;
        padding-bottom: 0.32rem;
    }
    .cmt-text {
        width: 100%;
        height: 2rem;
        padding: 0.18rem;
        border: 1px solid #ff1f4f;
        margin: 0 auto;
        box-sizing: border-box;
        border-radius: 0.08rem;
        outline: none;
        display: block;
    }
    .read-btn{
        width: 3.2rem;
        height: 0.64rem;
        border-radius: 0.06rem;
        font-size: 0.26rem;
        line-height: 0.64rem;
        text-align: center;
        box-sizing: border-box;
        font-weight: 700;
        float: right;
        background: #ff1f4f;
        color: #fff;
        margin-top: 0.3rem;
    }
    /*{{$t("cmt")}}展示区域*/
    .comment-area{
        width: 100%;
        padding: 0.2rem 0.4rem 0.2rem;
        box-sizing: border-box;
    }
    .comment-item {
        width: 100%;
        height: auto;
        padding: 0.4rem 0 0.4rem;
        border-bottom: 0.02rem solid #e6e6e6;
        display: flex;
    }
    .comment-item:last-child{
        border-bottom: none;
    }
    .comment-icon {
        display: flex;
        align-items: center;
        font-size: 0.2rem;
        color: #ff1f4f;
    }
    .comment-icon img {
        display: block;
        width: 0.32rem;
        height: 0.28rem;
    }
    .comment-icon span {
        padding-left: 0.1rem;
    }
    .user-photo {
        width: auto;
    }
    .photo-img{
        width: 0.64rem;
        height: 0.64rem;
        border-radius: 50%;
        overflow: hidden;
    }
    .user-photo img {
        display: block;
        width: 0.64rem;
        height: 0.64rem;
        border-radius: 50%;
    }
    .user-info {
        width: 5.6rem;
        padding-left: 0.4rem;
    }
    .user-name{
        font-size: 0.28rem;
        line-height: 0.28rem;
        color: #4d4d4d;
        font-weight: 700;
        padding: 0.06rem 0 0.1rem;
    }
    .comment-time{
        font-size: 0.2rem;
        line-height: 0.2rem;
        color: #666666;
        padding-bottom: 0.2rem;
    }
    .comment-con {
        font-size: 0.22rem;
        line-height: 0.3rem;
        color: #000000;
        padding-bottom: 0.2rem;
    }
    .zan-area {
        float: right;
        font-size: 0.2rem;
        color: #474443;
        display: flex;
        align-items: center;
    }
    .zan-area img {
        width: 0.32rem;
        height: 0.32rem;
        display: block;
    }
    .zan-area span {
        padding-left: 0.1rem;
        color: #666666;
    }
</style>


// WEBPACK FOOTER //
// src/components/cmtlist.vue